/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-param-reassign */
import { createReducer, createAction } from '@reduxjs/toolkit';

import { ValidatePromoRes } from '@/types';

export interface PromoInitialState {
  validatePromoRes: ValidatePromoRes;
  errorCode: '';
}

export const initialState: PromoInitialState = {
  errorCode: '',
  validatePromoRes: {
    promo_code: '',
    discount: 0,
    description: '',
    final_price: 0,
    name: '',
    all_payment: true,
  } as ValidatePromoRes,
};

const STORE_VALIDATE_PROMO = 'STORE_VALIDATE_PROMO';

export const getValidatePromoRes: (state: any) => ValidatePromoRes = (
  state: any
) => state.validatePromoRes;

export const storeValidatePromoRes = createAction(
  STORE_VALIDATE_PROMO,
  (payload: ValidatePromoRes) => {
    return {
      payload: {
        ...payload,
      },
    };
  }
);

export default createReducer(initialState, {
  [STORE_VALIDATE_PROMO]: (state, action) => {
    state.validatePromoRes = action.payload;
  },
});
